import { render } from "./ModalInc.vue?vue&type=template&id=85d55548"
import script from "./ModalInc.vue?vue&type=script&lang=js"
export * from "./ModalInc.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__